import { createContext, useState, useEffect } from "react";

export const AuthContext = createContext();

function decodeJwt(t) {
  try {
    return JSON.parse(atob(t.split(".")[1]));
  } catch {
    return null;
  }
}

export const AuthProvider = ({ children }) => {
  const initialToken = localStorage.getItem("token");
  const initialPayload = initialToken ? decodeJwt(initialToken) : null;

  const [token, setToken] = useState(initialToken);
  const [userEmail, setUserEmail] = useState(initialPayload?.email ?? null);
  const [userBackupType, setUserBackupType] = useState(
    initialPayload?.backuptype ?? null
  );
  const [permissionLevel, setPermissionLevel] = useState(
    initialPayload?.permission ?? null
  );

  // Mantém tudo sincronizado se o token mudar em runtime
  useEffect(() => {
    const p = token ? decodeJwt(token) : null;
    setUserEmail(p?.email ?? null);
    setUserBackupType(p?.backuptype ?? null);
    setPermissionLevel(p?.permission ?? null);
  }, [token]);

  const login = (newToken) => {
    localStorage.setItem("token", newToken);
    setToken(newToken);
    // atualiza imediatamente para não haver "janela" com null
    const p = decodeJwt(newToken);
    setUserEmail(p?.email ?? null);
    setUserBackupType(p?.backuptype ?? null);
    setPermissionLevel(p?.permission ?? null);
  };

  const logout = () => {
    localStorage.removeItem("token");
    setToken(null);
    setUserEmail(null);
    setUserBackupType(null);
    setPermissionLevel(null);
  };

  const isAuthenticated = !!token;

  return (
    <AuthContext.Provider
      value={{
        token,
        login,
        logout,
        isAuthenticated,
        userEmail,
        permissionLevel,
        userBackupType,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};
